import React, { useEffect, useState, createContext } from "react";
import { auth } from "../firebase/firebase";
import { getUserDetails } from "../Freightrates1/Utility";
import axios from "../../Axios/Axios";
import { Urls } from "../../Urls";

// Create a context for user details
export const UserApiContext = createContext({});

// UserDetailsContext component to provide user details throughout the app
export const UserDetailsContext = ({ children }) => {
  const [userDetails, setUserDetails] = useState({}); // State to store user
  const [companyProfile, setCompanyProfile] = useState({}); // State to store company profile data
  const [users, setUsers] = useState({}); // State to store userDetails profile data
  const [isContextLoading, setIsContextLoading] = useState(false);

  useEffect(() => {
    // Check if there is an authenticated user and a valid ID token
    if (auth && auth.currentUser && auth.currentUser.getIdToken()) {
      setIsContextLoading(true);

      // Fetch current user and update state
      axios
        .get(Urls.Users.GetCurrentUser)
        .then((res) => {
          setUsers(res.data);
          // Fetch user details and update state
          return getUserDetails();
        })
        .then((res) => {
          setUserDetails(res.data);
          if (res?.data?.email) {
            axios
              .get(`${Urls.companyProfile}?email=${res.data.email}`)
              .then((res) => {
                setCompanyProfile(res.data);
                // localStorage.setItem('profile_company_id', res?.data?.domain_data?.company_id);
              })
              .catch((error) => console.log(error));
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setIsContextLoading(false);
        });
    } else {
      setIsContextLoading(false);
    }
  }, []);

  // Provide user details and loading state through the context to its children
  return (
    <UserApiContext.Provider
      value={{
        userDetails,
        setUserDetails,
        companyProfile,
        setCompanyProfile,
        users,
        setUsers,
        isContextLoading,
      }}
    >
      {children}
    </UserApiContext.Provider>
  );
};
